import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const toggleDriverFactory = base => {
  const { element, exists } = baseUniDriverFactory(base);
  return {
    exists,
    element,
  };
};
